import React from "react";
import { Tooltip } from "antd";
import Divider from "../Divider";

const StockFL = ({
  totalStock,
  conversion = 1,
  showTooltip = true,
  className = "",
}) => {
  const stock = Number(totalStock) || 0;
  if (stock <= 0) return <span className={className}>0</span>;

  const full = Math.floor(stock);
  const loose = Math.floor((stock - full) * conversion + 1e-6);

  const content =
    loose > 0 ? (
      <span className="flex items-center justify-center">
        <span>{full}</span>
        <Divider height="1.5rem" />
        <span>{loose}</span>
      </span>
    ) : (
      <span>{full}</span>
    );

  if (loose > 0 && showTooltip) {
    return (
      <Tooltip
        placement="top"
        title={
          <div>
            <div>Full qty: {full}</div>
            <div>Loose qty: {loose}</div>
          </div>
        }
      >
        <span className={`flex justify-center ${className}`}>{content}</span>
      </Tooltip>
    );
  }

  return <span className={`flex justify-center ${className}`}>{content}</span>;
};

export default StockFL;
